import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import AssignRoleService from '../../services/user-role/role-service';
import { RolesSummaryDTO } from '../../models/user-role/role-model';

interface NewRoleSearchProps {
    onSearch: (selectedRole: number | null) => void;
    onReset: () => void;
    onAddClick: () => void;
}

const NewRoleSearch: React.FC<NewRoleSearchProps> = ({ onSearch, onReset, onAddClick }) => {
    const [selectedRole, setSelectedRole] = useState<number | null>(null);
    const [roleOptions, setRoleOptions] = useState<RolesSummaryDTO[]>([]);

    useEffect(() => {
        loadRoles();
    }, []);

    const loadRoles = async () => {
        try {
            const data = await AssignRoleService.getAllRoles();
            setRoleOptions(data.data || data || []);
        } catch (error) {
            console.error("Error loading roles", error);
        }
    };

    const handleSearch = () => {
        onSearch(selectedRole);
    };

    const handleReset = () => {
        setSelectedRole(null);
        onReset();
    };

    return (
        <div className="role-filter-bar">
            <div className="rc-filter-grid">
                <div className="rc-filter-field">
                    <label className="rc-filter-label">
                        <i className="pi pi-users"></i>
                        ROLE
                    </label>
                    <Dropdown
                        value={selectedRole}
                        options={roleOptions}
                        onChange={(e: DropdownChangeEvent) => setSelectedRole(e.value)}
                        optionLabel="name"
                        optionValue="roleId"
                        placeholder="Select Role"
                        className="rc-filter-dropdown w-full"
                        showClear
                        filter
                    />
                </div>

                <div className="rc-filter-actions">
                    <Button
                        label="Search"
                        icon="pi pi-search"
                        onClick={handleSearch}
                        className="rc-search-btn"
                    />
                    <Button
                        label="Reset"
                        icon="pi pi-refresh"
                        onClick={handleReset}
                        className="rc-reset-btn"
                    />
                    <Button
                        label="Create Role"
                        icon="pi pi-plus-circle"
                        onClick={onAddClick}
                        className="rc-create-role-btn"
                    />
                </div>
            </div>
        </div>
    );
};

export default NewRoleSearch;
